import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
	Avatar,
	Dropdown,
	Layout,
	Menu,
	Typography,
	Col,
	Row,
	Divider,
	Tooltip,
	Button
} from 'antd';
import { LogoutOutlined, FlagOutlined } from '@ant-design/icons';
import Spain from '../../assets/Banderas/Spain.svg';
import Cataluna from '../../assets/Banderas/Cataluna.svg';
import EstadosUnidos from '../../assets/Banderas/EstadosUnidos.png';
import sabadell from '../../assets/banks/sabadell-icon.svg';
import axios from 'axios';
import { useTranslation, withTranslation } from 'react-i18next';
import i18n from '../../i18n';
import env from '../../environment';
import { useSelector, useDispatch } from 'react-redux';
import { callAct, changeRol } from '../../store/auth/actions';
import { logout } from '../../store/auth/actions';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { isMobileOnly } from 'react-device-detect';
import { BookEditIcon, MessageQuestionIcon } from 'hugeicons-react';

const { Header } = Layout;
const { Text } = Typography;

function HeaderComponent() {
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const changeCallAct = useSelector((state) => state.auth.callAct);
	const rolUser = useSelector((state) => state.auth.roles);
	const dataProfile = useSelector((state) => state.data.dataProfile);
	const allRoles = dataProfile?.roles?.length > 0 ? dataProfile.roles : 'client';
	const brand = process.env.REACT_APP_BRAND;

	let temp =
		allRoles && Array.isArray(allRoles)
			? allRoles
			: allRoles && allRoles.length === 1 && allRoles[0] === 'realestate'
			? allRoles
			: allRoles && allRoles.split(',');
	let arrayRoles = temp;

	const userToken = useSelector((state) => state.auth.token);
	const { t } = useTranslation();
	const analytics = getAnalytics();

	useEffect(() => {
		dataPersonalOperation();
	}, [changeCallAct]);

	useEffect(() => {
		if (rolUser === 'realestate' && arrayRoles[0] === 'hadmin') {
			dispatch(changeRol('realestate'));
			localStorage.setItem('allRoles', ['realestate', 'client']);
		}
		dataPersonalOperation();
	}, []);

	const dataPersonalOperation = () => {
		axios
			.get(`${env.api.url}/v1/user/profile`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then(() => {
				dispatch(callAct(false));
			});
	};

	const changeLanguage = (lng) => {
		axios.patch(
			`${env.api.url}/v1/user/update-user-language`,
			{
				language: lng
			},
			{
				headers: { Authorization: `Bearer ${userToken}` }
			}
		);
		i18n.changeLanguage(lng);
	};

	const logoutUser = () => {
		logEvent(analytics, 'select_content', {
			content_type: 'configuration.list',
			content_id: 'user.logout'
		});
		dispatch(logout({ navigate }));
	};

	const menu = (
		<Menu
			className="language-menu"
			onClick={({ key }) => {
				if (['es', 'en', 'cat'].includes(key)) {
					changeLanguage(key);
				} else if (key === 'logout') {
					logoutUser();
				}
			}}>
			<Menu.Item key="es">
				<img src={Spain} alt="Spain Flag" height="15px" style={{ marginRight: 5 }} />
				{t('form.es')}
			</Menu.Item>
			<Menu.Item key="en">
				<img src={EstadosUnidos} alt="US Flag" height="15px" style={{ marginRight: 5 }} />
				{t('form.en')}
			</Menu.Item>
			<Menu.Item key="cat">
				<img src={Cataluna} alt="Catalonia Flag" height="15px" style={{ marginRight: 5 }} />
				{t('form.cat')}
			</Menu.Item>
			<Menu.Divider />
			<Menu.Item key="logout">
				<LogoutOutlined />
				<Text style={{ marginLeft: 12, fontWeight: '600' }}>{t('init.logout')}</Text>
			</Menu.Item>
		</Menu>
	);

	const typeClients = {
		client: t('header.particular'),
		realestate: t('header.company'),
		friend: t('header.plain'),
		hadmin: t('hadmin'),
		undefined: t('header.particular')
	};

	return (
		<Row>
			<Col sm={24} xs={24} lg={24} xl={24}>
				<Header
					className="ant-layout-header"
					style={{ alignItems: 'center', padding: isMobileOnly ? '0px 16px' : '0px 32px' }}>
					<div style={{ display: 'flex', alignItems: 'center', height: 36 }}>
						<img
							src={sabadell}
							style={{
								height: 32,
								alignSelf: 'center',
								margin: 16,
								marginLeft: 0
							}}
							alt="Sabadell logo"
						/>
						<Divider type="vertical" style={{ borderColor: '#fff', height: 35, margin: 0 }} />
						<h1 style={{ fontSize: 14, fontWeight: 700, marginLeft: 16, color: '#fff' }}>
							{t('createMortgageComponent.mortgagesTitle')}
						</h1>
					</div>
					<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
						<Tooltip title={t('manual.user')}>
							<Button
								aria-label={t('help')}
								onClick={() => navigate('/help')}
								style={{ background: 'transparent', border: 'none', padding: 0, marginTop: 6 }}>
								<BookEditIcon
									style={{
										color: location.pathname === '/help' ? '#006DFF' : '#fff',
										cursor: 'pointer'
									}}
								/>
							</Button>
						</Tooltip>
						<div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'center' }}>
							<Text
								style={{
									textAlign: 'right',
									fontWeight: 700,
									color: '#FFFFFF',
									fontSize: 12,
									lineHeight: '14px'
								}}>
								{dataProfile && isMobileOnly ? dataProfile.name.substr(0, 10) : dataProfile.name}
							</Text>
							<Text
								style={{
									fontWeight: 400,
									lineHeight: '14px',
									color: '#FFFFFF',
									fontSize: 12
								}}>
								{typeClients[rolUser]}
							</Text>
						</div>
						<Dropdown overlay={menu} placement="bottomRight" arrow trigger={['click']}>
							<Avatar
								tabIndex={0}
								role="button"
								aria-haspopup="menu"
								aria-expanded={false}
								onKeyDown={(e) => {
									if (e.key === 'Enter' || e.key === ' ') {
										e.preventDefault();
										e.currentTarget.click();
									}
								}}
								style={{
									backgroundColor: '#6E6E6E',
									color: '#FFFFFF',
									fontWeight: 700,
									cursor: 'pointer'
								}}
								size={32}>
								{dataProfile?.name?.charAt(0) + dataProfile?.surname?.charAt(0)}
							</Avatar>
						</Dropdown>
					</div>
				</Header>
			</Col>
		</Row>
	);
}

export default withTranslation()(HeaderComponent);
